import React, { useContext, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { AuthContext } from '../../../component/context/AuthContext';

function ShowDocuments({ closeDocumentModal, editEmpId, firstName, lastName }) {
  const [show, setShow] = useState('show');
  const [authUserData, setAuthUserData] = useContext(AuthContext);
  let isToken = '';
  let user_id = '';
  let department_id = '';
  let is_head = 0;
  let is_admin = 0;
  let hr_head = 0;
  let default_dpt_id = '';
  if (authUserData) {
    if (authUserData[0]) {
      isToken = authUserData[0].token ? authUserData[0].token : "";
      user_id = authUserData[0].user_id ? authUserData[0].user_id : "";
      is_head = authUserData[0].is_head ? authUserData[0].is_head : 0;
      is_admin = authUserData[0].is_admin ? authUserData[0].is_admin : 0;
      hr_head = authUserData[0].hr_head ? authUserData[0].hr_head : 0;
      department_id = authUserData[0].department_id ? authUserData[0].department_id : "";
    }
  }
  return (
    <Modal
      size="xl"
      show={show}
      onHide={() => closeDocumentModal('hide')}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <h6>View Documents - {firstName} {lastName}</h6>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: 'rgb(241, 245, 249)' }}>
        <div className="row">
          <div className="col-12 p-3">
            <div className='pt-3'>
              <h5>
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-file-description color_blue mr-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
                  <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>
                  <path d="M9 17h6"></path>
                  <path d="M9 13h6"></path>
                </svg>
                Uploaded Documents Here
              </h5>
              <hr />
            </div>
            <div className='row'>
              <div className='col-md-4'>Employee's Submitted Document here</div>
            </div>
          </div>

          {
            (is_admin == 1 || department_id == 5 || department_id == 8) && (
              <>
                <div className="col-12 p-3">
                  <div className='pt-3'>
                    <h5>
                      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-file-description color_blue mr-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
                        <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>
                        <path d="M9 17h6"></path>
                        <path d="M9 13h6"></path>
                      </svg>
                      For HR Department
                    </h5>
                    <hr />

                  </div>
                  <div className='row'>
                    <div className='col-md-4'>
                      Optional (If not submitted during recruitment process)<br />
                      1) Scanned NDA Upload by Concern HR<br />
                      2) Scanned Offer Letter and Appointment letter upload by Concern HR<br />
                    </div>
                  </div>
                </div>
              </>
            )
          }

        </div>
      </Modal.Body>
    </Modal >
  )
}
export default ShowDocuments